import { generatePath, useNavigate } from 'react-router-dom';
import { useInternationalization } from '../../../hooks';
import { ChangeLogEntity } from '../../../models';
import { ChangeLogEntityType } from '../../../types';
import { ChangeLogItem } from '../../ChangeLog';
import { routes } from '../../../routes';

interface BuyGuideVendorChangeLogItemProps {
  item: ChangeLogEntity;
  vendorId: number;
}

export const BuyGuideVendorChangeLogItem = ({ item, vendorId }: BuyGuideVendorChangeLogItemProps) => {
  const { t, getTranslation } = useInternationalization();
  const navigate = useNavigate();

  const renderValue = () => {
    switch (item.entityType) {
      case ChangeLogEntityType.RebateProgram:
        return item.changeReason_En
          ? t('changeLog:buyGuideRebateProgram.detailReason', {
              name: getTranslation(item, 'entityName'),
              id: item.number,
              reason: getTranslation(item, 'changeReason'),
            })
          : t('changeLog:buyGuideRebateProgram.detail', {
              name: getTranslation(item, 'entityName'),
              id: item.number,
            });
      case ChangeLogEntityType.Document:
      case ChangeLogEntityType.GeneralConditions:
      case ChangeLogEntityType.Contact:
      case ChangeLogEntityType.Location:
      case ChangeLogEntityType.BuyOpportunity:
        return getTranslation(item, 'entityName');
      default:
        break;
    }
    return '';
  };

  const handleClick = (item: ChangeLogEntity) => {
    if (item.entityType === ChangeLogEntityType.RebateProgram) {
      return () =>
        navigate(
          generatePath(routes.Member.BuyGuideRebateProgramDetail.path, {
            vendorId: vendorId,
            rebateProgramId: item.id,
          }),
        );
    }
  };

  return (
    <ChangeLogItem
      item={item}
      renderValue={(item) =>
        t(`changeLog:buyGuideEntityType.${item.entityType}`, {
          action: item.changeLogActionType,
          fullName: item.loggedBy,
          description: item.description,
          value: renderValue(),
        })
      }
      onClick={handleClick(item)}
    />
  );
};
